"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function arr_back(arr) {
  return arr[arr.length - 1];
}
exports.default = arr_back;